<template>
  <div class="workbench-container">
    <div class="workbench-header">
      <div class="header-title">工作台</div>
      <div class="header-info">
        <span class="user-name">{{ userName }}</span>
        <span class="user-role">{{ roleName }}</span>
      </div>
    </div>

    <div class="workbench-content">
      <!-- 系统管理区域 - 仅管理员可见 -->
      <div class="section" v-if="hasPcPermission('employee-manage') || hasPcPermission('role-manage') || hasPcPermission('permission-config')">
        <div class="section-title">
          <i class="el-icon-s-tools"></i>
          系统管理
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goEmployeeManage" v-if="hasPcPermission('employee-manage')">
            <div class="menu-icon employee">
              <i class="el-icon-user"></i>
            </div>
            <div class="menu-text">员工管理</div>
          </div>
          <div class="menu-item" @click="goRoleManage" v-if="hasPcPermission('role-manage')">
            <div class="menu-icon role">
              <i class="el-icon-postcard"></i>
            </div>
            <div class="menu-text">角色管理</div>
          </div>
          <div class="menu-item" @click="goPermissionConfig" v-if="hasPcPermission('permission-config')">
            <div class="menu-icon permission">
              <i class="el-icon-key"></i>
            </div>
            <div class="menu-text">权限配置</div>
          </div>
        </div>
      </div>

      <!-- 考勤管理区域 -->
      <div class="section" v-if="hasPcPermission('checkin-manage') || hasPcPermission('leave-approve') || hasPcPermission('makeup-approve')">
        <div class="section-title">
          <i class="el-icon-time"></i>
          考勤管理
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goCheckinStats" v-if="hasPcPermission('checkin-manage')">
            <div class="menu-icon checkin">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="menu-text">考勤统计</div>
          </div>
          <div class="menu-item" @click="goLeaveApproval" v-if="hasPcPermission('leave-approve')">
            <div class="menu-icon leave">
              <i class="el-icon-document"></i>
            </div>
            <div class="menu-text">请假审批</div>
          </div>
          <div class="menu-item" @click="goMakeupApproval" v-if="hasPcPermission('makeup-approve')">
            <div class="menu-icon makeup">
              <i class="el-icon-edit"></i>
            </div>
            <div class="menu-text">补卡审批</div>
          </div>
        </div>
      </div>

      <!-- 学员管理区域 -->
      <div class="section" v-if="hasPcPermission('student-manage')">
        <div class="section-title">
          <i class="el-icon-user-solid"></i>
          学员管理
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goStudentList">
            <div class="menu-icon student">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="menu-text">学员列表</div>
          </div>
          <div class="menu-item" @click="goPaymentList" v-if="hasPcPermission('payment-audit')">
            <div class="menu-icon payment">
              <i class="el-icon-coin"></i>
            </div>
            <div class="menu-text">缴费管理</div>
          </div>
          <div class="menu-item" @click="goTrainStats">
            <div class="menu-icon train">
              <i class="el-icon-reading"></i>
            </div>
            <div class="menu-text">培训统计</div>
          </div>
          <div class="menu-item" @click="goExamRecord">
            <div class="menu-icon exam">
              <i class="el-icon-document-checked"></i>
            </div>
            <div class="menu-text">考试成绩</div>
          </div>
        </div>
      </div>

      <!-- 客户管理区域 -->
      <div class="section" v-if="hasPcPermission('customer-manage')">
        <div class="section-title">
          <i class="el-icon-user"></i>
          客户管理
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goCustomerManage">
            <div class="menu-icon customer-icon">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="menu-text">客户列表</div>
          </div>
        </div>
      </div>

      <!-- 司机任务区域 -->
      <div class="section" v-if="hasPcPermission('driver-manage')">
        <div class="section-title">
          <i class="el-icon-truck"></i>
          司机任务
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goDriverTaskList">
            <div class="menu-icon task">
              <i class="el-icon-location-information"></i>
            </div>
            <div class="menu-text">任务列表</div>
          </div>
          <div class="menu-item" @click="goTripRecord">
            <div class="menu-icon trip">
              <i class="el-icon-map-location"></i>
            </div>
            <div class="menu-text">行程记录</div>
          </div>
          <div class="menu-item" @click="goDriverStats">
            <div class="menu-icon stats">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div class="menu-text">接送统计</div>
          </div>
        </div>
      </div>


      <!-- 财务模块区域 -->
      <div class="section" v-if="hasPcPermission('finance-manage')">
        <div class="section-title">
          <i class="el-icon-money"></i>
          财务管理
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goCollectionList">
            <div class="menu-icon collection">
              <i class="el-icon-bank-card"></i>
            </div>
            <div class="menu-text">收款审核</div>
          </div>
          <div class="menu-item" @click="goRefundList">
            <div class="menu-icon refund">
              <i class="el-icon-document-delete"></i>
            </div>
            <div class="menu-text">退费处理</div>
          </div>
          <div class="menu-item" @click="goFinanceReport">
            <div class="menu-icon report">
              <i class="el-icon-notebook-2"></i>
            </div>
            <div class="menu-text">财务报表</div>
          </div>
        </div>
      </div>

      <!-- 薪资核算区域 -->
      <div class="section" v-if="hasPcPermission('salary-manage')">
        <div class="section-title">
          <i class="el-icon-wallet"></i>
          薪资核算
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goSalaryCalc">
            <div class="menu-icon salary">
              <i class="el-icon-c-scale-to-original"></i>
            </div>
            <div class="menu-text">薪资计算</div>
          </div>
          <div class="menu-item" @click="goSalaryReport">
            <div class="menu-icon report">
              <i class="el-icon-tickets"></i>
            </div>
            <div class="menu-text">工资台账</div>
          </div>
        </div>
      </div>

      <!-- 业务员业绩区域 -->
      <div class="section" v-if="hasPcPermission('sales-report')">
        <div class="section-title">
          <i class="el-icon-trend-charts"></i>
          业绩统计
        </div>
        <div class="menu-grid">
          <div class="menu-item" @click="goSalesReport">
            <div class="menu-icon report">
              <i class="el-icon-pie-chart"></i>
            </div>
            <div class="menu-text">业绩报表</div>
          </div>
          <div class="menu-item" @click="goCustomerList">
            <div class="menu-icon customer">
              <i class="el-icon-user"></i>
            </div>
            <div class="menu-text">客户跟进</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能页面区域（点击菜单后显示） -->
    <div class="feature-panel" v-if="activeFeature">
      <div class="page-header">
        <div class="header-left">
          <i class="el-icon-arrow-left" @click="closeFeature"></i>
          <span class="page-title">{{ activeFeatureTitle }}</span>
        </div>
        <el-button type="primary" size="small" v-if="showAddBtn" @click="handleAdd">
          <i class="el-icon-plus"></i> {{ addBtnText }}
        </el-button>
      </div>

      <div class="panel-content">
        <!-- 考勤统计 -->
        <div v-if="activeFeature === 'checkin-stats'" class="feature-content">
          <el-card class="stats-card">
            <div class="stats-header">本月考勤概览</div>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="stat-item">
                  <div class="stat-value">{{ statsData.normal }}</div>
                  <div class="stat-label">正常</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item">
                  <div class="stat-value warning">{{ statsData.late }}</div>
                  <div class="stat-label">迟到</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item">
                  <div class="stat-value warning">{{ statsData.early }}</div>
                  <div class="stat-label">早退</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stat-item">
                  <div class="stat-value danger">{{ statsData.absent }}</div>
                  <div class="stat-label">缺卡</div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-table :data="checkinList" style="width: 100%; margin-top: 20px;" stripe>
            <el-table-column prop="date" label="日期" width="120"></el-table-column>
            <el-table-column prop="checkinTime" label="上班打卡" width="150"></el-table-column>
            <el-table-column prop="checkoutTime" label="下班打卡" width="150"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.statusText }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="location" label="打卡位置"></el-table-column>
          </el-table>
        </div>

        <!-- 请假审批 -->
        <div v-if="activeFeature === 'leave-list'" class="feature-content">
          <el-tabs>
            <el-tab-pane label="待审批">
              <el-table :data="leavePending" style="width: 100%">
                <el-table-column prop="userName" label="申请人" width="100"></el-table-column>
                <el-table-column prop="leaveType" label="请假类型" width="120"></el-table-column>
                <el-table-column prop="leaveDate" label="请假日期" width="120"></el-table-column>
                <el-table-column prop="reason" label="原因"></el-table-column>
                <el-table-column prop="applyTime" label="申请时间" width="160"></el-table-column>
                <el-table-column label="操作" width="320">
                  <template slot-scope="scope">
                    <el-button type="text" @click="approveLeave(scope.row, 'APPROVED')">通过</el-button>
                    <el-button type="text" @click="approveLeave(scope.row, 'REJECTED')">拒绝</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="已审批">
              <el-table :data="leaveApproved" style="width: 100%">
                <el-table-column prop="userName" label="申请人" width="100"></el-table-column>
                <el-table-column prop="leaveType" label="请假类型" width="120"></el-table-column>
                <el-table-column prop="leaveDate" label="请假日期" width="120"></el-table-column>
                <el-table-column prop="status" label="审批结果" width="100"></el-table-column>
                <el-table-column prop="approveRemark" label="审批备注"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 补卡审批 -->
        <div v-if="activeFeature === 'makeup-list'" class="feature-content">
          <el-tabs>
            <el-tab-pane label="待审批">
              <el-table :data="makeupPending" style="width: 100%">
                <el-table-column prop="userName" label="申请人" width="100"></el-table-column>
                <el-table-column prop="makeupDate" label="补卡日期" width="120"></el-table-column>
                <el-table-column prop="checkinType" label="补卡类型" width="100"></el-table-column>
                <el-table-column prop="reason" label="补卡原因"></el-table-column>
                <el-table-column label="操作" width="320">
                  <template slot-scope="scope">
                    <el-button type="text" @click="approveMakeup(scope.row, 'APPROVED')">通过</el-button>
                    <el-button type="text" @click="approveMakeup(scope.row, 'REJECTED')">拒绝</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="已审批">
              <el-table :data="makeupApproved" style="width: 100%">
                <el-table-column prop="userName" label="申请人" width="100"></el-table-column>
                <el-table-column prop="makeupDate" label="补卡日期" width="120"></el-table-column>
                <el-table-column prop="status" label="审批结果" width="100"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 学员列表 -->
        <div v-if="activeFeature === 'student-list'" class="feature-content">
          <div class="search-bar">
            <el-input placeholder="搜索学员姓名/电话" v-model="studentKeyword" style="width: 300px;" clearable>
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="studentStatus" placeholder="学员状态" style="width: 150px; margin-left: 10px;" clearable>
              <el-option label="全部状态" value="" />
              <el-option label="潜在" value="POTENTIAL"></el-option>
              <el-option label="在学" value="ACTIVE"></el-option>
              <el-option label="毕业" value="COMPLETED"></el-option>
              <el-option label="退学" value="DROPPED"></el-option>
            </el-select>
          </div>
          <el-table :data="filteredStudents" style="width: 100%; margin-top: 15px;" stripe>
            <el-table-column prop="studentName" label="姓名" width="100"></el-table-column>
            <el-table-column prop="contactPhone" label="电话" width="120"></el-table-column>
            <el-table-column prop="examType" label="报考车型" width="100"></el-table-column>
            <el-table-column prop="currentSubject" label="当前科目" width="100"></el-table-column>
            <el-table-column prop="paymentStatus" label="缴费状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getPaymentStatusType(scope.row.paymentStatus)">{{ scope.row.paymentStatusText }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="studentStatus" label="学员状态" width="100">
              <template slot-scope="scope">
                <el-tag>{{ scope.row.studentStatusText }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="salesUserName" label="归属业务员" width="100"></el-table-column>
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-button type="text" @click="viewStudent(scope.row)">查看</el-button>
                <el-button type="text" @click="editStudent(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 司机任务列表 -->
        <div v-if="activeFeature === 'driver-task-list'" class="feature-content">
          <div class="search-bar">
            <el-select v-model="taskStatus" placeholder="任务状态" style="width: 150px;" clearable>
              <el-option label="全部状态" value="" />
              <el-option label="待接单" value="PENDING"></el-option>
              <el-option label="已接单" value="ACCEPTED"></el-option>
              <el-option label="已接到" value="PICKED"></el-option>
              <el-option label="已送达" value="ARRIVED"></el-option>
              <el-option label="已取消" value="CANCELLED"></el-option>
            </el-select>
          </div>
          <el-table :data="driverTasks" style="width: 100%; margin-top: 15px;" stripe>
            <el-table-column prop="taskNo" label="任务编号" width="140"></el-table-column>
            <el-table-column prop="taskType" label="任务类型" width="120">
              <template slot-scope="scope">
                {{ scope.row.taskType === 'STATION_PICKUP' ? '车站接学员' : '考场往返' }}
              </template>
            </el-table-column>
            <el-table-column prop="studentName" label="学员姓名" width="100"></el-table-column>
            <el-table-column prop="driverName" label="司机" width="100"></el-table-column>
            <el-table-column prop="scheduledTime" label="计划时间" width="160"></el-table-column>
            <el-table-column prop="taskStatus" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getTaskStatusType(scope.row.taskStatus)">{{ scope.row.taskStatusText }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-button type="text" @click="viewTask(scope.row)">查看</el-button>
                <el-button type="text" @click="assignDriver(scope.row)">指派</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 更多功能提示 -->
        <div v-if="['payment-list', 'train-stats', 'trip-record', 'driver-stats', 'my-students', 'train-sign', 'exam-record', 'collection-list', 'refund-list', 'finance-report', 'salary-calc', 'salary-report', 'sales-report', 'customer-list'].includes(activeFeature)" class="feature-content placeholder">
          <i class="el-icon-loading"></i>
          <p>{{ activeFeatureTitle }} - 功能开发中</p>
          <p class="tip">具体功能将在后续事项中实现</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyPcPermissions } from '@/api/rolePermissionApi'

export default {
  name: 'Workbench',
  data() {
    return {
      activeFeature: null,
      activeFeatureTitle: '',
      pcPermissions: [], // PC端权限列表
      
      // 按钮配置
      showAddBtn: false,
      addBtnText: '新建',
      
      // 考勤统计数据
      statsData: {
        normal: 18,
        late: 2,
        early: 1,
        absent: 0
      },
      checkinList: [
        { date: '2026-08-12', checkinTime: '08:30', checkoutTime: '18:05', status: 'NORMAL', statusText: '正常', location: '基地WiFi' },
        { date: '2026-08-11', checkinTime: '08:35', checkoutTime: '17:50', status: 'LATE', statusText: '迟到', location: '基地WiFi' },
        { date: '2026-08-10', checkinTime: '08:28', checkoutTime: '--', status: 'ABSENT', statusText: '缺卡', location: '--' },
      ],
      
      // 请假数据
      leavePending: [
        { id: 1, userName: '张三', leaveType: '半天假', leaveDate: '2026-08-15', reason: '身体不适', applyTime: '2026-08-12 10:30' },
        { id: 2, userName: '李四', leaveType: '1天', leaveDate: '2026-08-16', reason: '家中有事', applyTime: '2026-08-12 09:15' },
      ],
      leaveApproved: [],
      
      // 补卡数据
      makeupPending: [
        { id: 1, userName: '王五', makeupDate: '2026-08-10', checkinType: '下班', reason: '忘记打卡' },
      ],
      makeupApproved: [],
      
      // 学员数据
      studentKeyword: '',
      studentStatus: '',
      students: [
        { id: 1, studentName: '张小明', contactPhone: '13800138001', examType: 'C1', currentSubject: '科目二', paymentStatus: 'PAID', paymentStatusText: '已缴清', studentStatus: 'ACTIVE', studentStatusText: '在学', salesUserName: '业务员A' },
        { id: 2, studentName: '李小红', contactPhone: '13800138002', examType: 'C2', currentSubject: '科目三', paymentStatus: 'PARTIAL', paymentStatusText: '部分缴清', studentStatus: 'ACTIVE', studentStatusText: '在学', salesUserName: '业务员B' },
        { id: 3, studentName: '王大力', contactPhone: '13800138003', examType: 'C1', currentSubject: '科目一', paymentStatus: 'UNPAID', paymentStatusText: '未缴清', studentStatus: 'POTENTIAL', studentStatusText: '潜在', salesUserName: '业务员A' },
      ],
      
      // 司机任务数据
      taskStatus: '',
      driverTasks: [
        { id: 1, taskNo: 'TASK-202608001', taskType: 'STATION_PICKUP', studentName: '张小明', driverName: '司机A', scheduledTime: '2026-08-12 14:00', taskStatus: 'PENDING', taskStatusText: '待接单' },
        { id: 2, taskNo: 'TASK-202608002', taskType: 'EXAM_SHUTTLE', studentName: '李小红', driverName: '司机B', scheduledTime: '2026-08-13 08:00', taskStatus: 'ACCEPTED', taskStatusText: '已接单' },
      ]
    }
  },
  computed: {
    userName() {
      return this.userStore.userInfo?.nickName || this.userStore.userInfo?.userName || localStorage.getItem('username') || '用户'
    },
    userRole() {
      // 优先从 localStorage 获取（登录时保存）
      const savedRole = localStorage.getItem('userRole')
      if (savedRole) {
        return savedRole
      }
      // 其次从 userStore 获取
      const storeRole = this.userStore.userInfo?.userRole
      if (storeRole) {
        return storeRole
      }
      // 默认为 ADMIN（便于初次维护）
      return 'ADMIN'
    },
    roleName() {
      const roleMap = {
        'ADMIN': '系统管理员',
        'EXECUTIVE': '高管',
        'STAFF': '内勤',
        'COACH': '教练',
        'DRIVER': '司机',
        'SALES': '业务员',
        'FINANCE': '财务',
        'HR': '人事'
      }
      return roleMap[this.userRole] || '员工'
    },
    // 判断是否有PC端权限
    filteredStudents() {
      let result = this.students
      if (this.studentKeyword) {
        const kw = this.studentKeyword.toLowerCase()
        result = result.filter(s => 
          s.studentName.toLowerCase().includes(kw) || 
          s.contactPhone.includes(kw)
        )
      }
      if (this.studentStatus) {
        result = result.filter(s => s.studentStatus === this.studentStatus)
      }
      return result
    }
  },
  mounted() {
    this.loadPcPermissions()
  },
  methods: {
    // 加载PC端权限
    async loadPcPermissions() {
      try {
        const res = await getMyPcPermissions()
        this.pcPermissions = res || []
      } catch (e) {
        console.log('获取PC权限失败，使用默认权限')
        // 默认全部权限
        this.pcPermissions = ['checkin-manage', 'leave-approve', 'makeup-approve', 'student-manage', 'customer-manage', 'payment-audit', 'driver-manage', 'finance-manage', 'salary-manage', 'sales-report']
      }
    },
    // 判断是否有PC端权限
    hasPcPermission(perm) {
      return this.pcPermissions.includes(perm)
    },
    
    // 打开功能面板
    openFeature(feature, title, showAdd = false, addText = '新建') {
      this.activeFeature = feature
      this.activeFeatureTitle = title
      this.showAddBtn = showAdd
      this.addBtnText = addText
    },
    
    // 关闭功能面板
    closeFeature() {
      this.activeFeature = null
      this.activeFeatureTitle = ''
      this.showAddBtn = false
    },
    
    // 新建按钮处理
    handleAdd() {
      this.$message.info('新建功能开发中')
    },

    // 控制台相关 - 跳转到独立页面
    goEmployeeManage() {
      this.$router.push('/home/employee-manage')
    },
    goRoleManage() {
      this.$router.push('/home/role-manage')
    },
    goPermissionConfig() {
      this.$router.push('/home/permission-config')
    },

    // 考勤相关 - 跳转到独立页面
    goCheckin() {
      this.$message.info('打卡功能请使用手机APP')
    },
    goCheckinStats() {
      this.$router.push('/home/checkin-stats')
    },
    goLeaveApproval() {
      this.$router.push('/home/leave-approval')
    },
    goMakeupApproval() {
      this.$router.push('/home/makeup-approval')
    },
    
    // 审批操作
    approveLeave(row, status) {
      this.$confirm(`确定${status === 'APPROVED' ? '通过' : '拒绝'}该请假申请?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const item = { ...row, status: status === 'APPROVED' ? '已通过' : '已拒绝' }
        this.leaveApproved.push(item)
        this.leavePending = this.leavePending.filter(l => l.id !== row.id)
        this.$message.success('操作成功')
      }).catch(() => {})
    },
    approveMakeup(row, status) {
      this.$confirm(`确定${status === 'APPROVED' ? '通过' : '拒绝'}该补卡申请?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const item = { ...row, status: status === 'APPROVED' ? '已通过' : '已拒绝' }
        this.makeupApproved.push(item)
        this.makeupPending = this.makeupPending.filter(m => m.id !== row.id)
        this.$message.success('操作成功')
      }).catch(() => {})
    },
    
    // 学员相关
    goStudentList() {
      this.$router.push('/home/student-manage')
    },
    goCustomerManage() {
      this.$router.push('/home/customer-manage')
    },
    viewStudent(row) {
      this.$message.info(`查看学员: ${row.studentName}`)
    },
    editStudent(row) {
      this.$message.info(`编辑学员: ${row.studentName}`)
    },
    goPaymentList() {
      this.$router.push('/home/student-manage?tab=payment')
    },
    goTrainStats() {
      this.$router.push('/home/student-manage?tab=train-stats')
    },
    goExamRecord() {
      this.$router.push('/home/student-manage?tab=exam')
    },
    
    // 司机相关
    goDriverTaskList() {
      this.$router.push('/home/driver-task-manage?tab=task')
    },
    goTripRecord() {
      this.$router.push('/home/driver-task-manage?tab=trip')
    },
    goDriverStats() {
      this.$router.push('/home/driver-task-manage?tab=stats')
    },
    viewTask(row) {
      this.$message.info(`查看任务: ${row.taskNo}`)
    },
    assignDriver(row) {
      this.$message.info(`指派司机: ${row.taskNo}`)
    },
    
    
    // 财务相关
    goCollectionList() {
      this.openFeature('collection-list', '收款审核')
    },
    goRefundList() {
      this.openFeature('refund-list', '退费处理')
    },
    goFinanceReport() {
      this.openFeature('finance-report', '财务报表')
    },
    
    // 薪资相关
    goSalaryCalc() {
      this.openFeature('salary-calc', '薪资计算')
    },
    goSalaryReport() {
      this.openFeature('salary-report', '工资台账')
    },
    
    // 业绩相关
    goSalesReport() {
      this.openFeature('sales-report', '业绩报表')
    },
    goCustomerList() {
      this.openFeature('customer-list', '客户跟进')
    },
    
    // 状态格式化
    getStatusType(status) {
      const map = { 'NORMAL': 'success', 'LATE': 'warning', 'EARLY': 'warning', 'ABSENT': 'danger' }
      return map[status] || 'info'
    },
    getPaymentStatusType(status) {
      const map = { 'PAID': 'success', 'PARTIAL': 'warning', 'UNPAID': 'danger' }
      return map[status] || 'info'
    },
    getTaskStatusType(status) {
      const map = { 'PENDING': 'warning', 'ACCEPTED': 'primary', 'PICKED': 'success', 'ARRIVED': 'success', 'CANCELLED': 'info' }
      return map[status] || 'info'
    }
  }
}
</script>

<style scoped>
.workbench-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
}

.workbench-header {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: #fff;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 24px;
  font-weight: bold;
}

.header-info {
  text-align: right;
}

.user-name {
  font-size: 16px;
  margin-right: 12px;
}

.user-role {
  background: rgba(255,255,255,0.2);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.workbench-content {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 8px;
  color: #409eff;
  font-size: 18px;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.menu-item:hover {
  background: #f0f7ff;
}

.menu-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 24px;
  color: #fff;
}

.menu-icon i {
  font-size: 24px;
}

.menu-icon.checkin { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.menu-icon.employee { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.role { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.menu-icon.permission { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.menu-icon.leave { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.menu-icon.makeup { background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%); }
.menu-icon.stats { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.student { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.menu-icon.payment { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.menu-icon.train { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.task { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.trip { background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%); }
.menu-icon.sign { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.menu-icon.exam { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.menu-icon.collection { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.menu-icon.refund { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.menu-icon.report { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.salary { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.salary { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.menu-icon.customer { background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%); }
.menu-icon.customer-icon { background: linear-gradient(135deg, #9c27b0 0%, #ba68c8 100%); }

.menu-text {
  font-size: 13px;
  color: #606266;
  text-align: center;
}

/* 功能面板 */
.feature-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: calc(100% - 80px);
  height: 100%;
  background: #f5f7fa;
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
  transition: color 0.2s;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.panel-content {
  flex: 1;
  overflow: auto;
  padding: 20px;
}

.panel-content.has-search {
  background: #f5f7fa;
}

.feature-content {
  height: 100%;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}

.stats-card {
  margin-bottom: 20px;
}

.stats-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}

.stat-item {
  text-align: center;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #67c23a;
}

.stat-value.warning {
  color: #e6a23c;
}

.stat-value.danger {
  color: #f56c6c;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}

.placeholder i {
  font-size: 48px;
  margin-bottom: 16px;
}

.placeholder p {
  margin: 4px 0;
}

.placeholder .tip {
  font-size: 12px;
  color: #c0c4cc;
}
</style>
